module.exports = __webpack_public_path__ + "media/img/illustrations/icon-loader-0f6c439bf665125fd4909a186468d908.svg";